import Table from "../../../../../../common/components/molecule/Table/Table";
import styles from "./PaygoListView.module.scss";
export interface PaygoListViewProps {

  content: PaygoItem[];
  nbFound?: number;
}

export interface PaygoItem {
  id: string;
  createAt?: string; 
  kWhAmount?: string | number; 
  code?: string;
  amountPrice?: number;
  userId?: string;
  organizationRender?: () => JSX.Element;
  onClick?: () => void;
  currency?: string;
  phoneNumber? : string;
  forRender?: () => JSX.Element;

  
}

export default function PaygoListView({content, nbFound}: PaygoListViewProps) {
  return (
    <div>
      <Table headerTitle={['kWh', 'Code', 'Pour','Organisation', 'Créé le']} bodyData={
        content.map((item) => {
          return {
            id: item.id,
            onRowClick: item.onClick,
            data: [item.kWhAmount || "NA", () => <PaygoCode code={item.code || "NA"}/> , item.forRender , item.organizationRender , item.createAt]
          }
        })
      } 
      
      emptyMessage="Aucun paygo trouvé"

      NbFoundViewProps={{
        nbFound: nbFound,
        itemName: { single: "paygo trouvé",
        plurial: "paygos trouvés" }
      }}
      />
    </div>
  )
}
const formatCode = (code?: string, separator: string = ' ') => {
  if (!code) return '';
  return code.split('').reduce((acc, char, index) => {
    return acc + (index > 0 && index % 5 === 0 ? (separator): '') + char;
  }, '');
};

const PaygoCode = ({code}:{code?: string}) => {


  
  return (
    <div className={[styles["paygo-code"]].join(" ")}>
      <span>{formatCode(code, ' - ')}</span>
    </div>
  )
} 
